import React, { useState, useEffect } from 'react';
// MANAGER
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getPerformanceData } from '@Managers/Redux/AppState/AppState';

// CSS
import styles from './PhaserStatus.scss';
import { qualityCheck } from './PhaserStatus.qualitycheck';

const FPSMetric: React.FC<{}> = () => {
    const maxFpsData = 300;
    const performance = useAppSelector(getPerformanceData);
    const [fpsData, setFpsData] = useState<Array<number>>([]);

    function mergeFpsData(element: number) {
        let data = fpsData;
        if (data.length > maxFpsData) data.shift();
        return [...data, element];
    }

    useEffect(() => {
        setFpsData(mergeFpsData(performance.actualFps));
    }, [performance]);

    function returnGroup() {
        let pixels = [];

        for (var i = 0; i < fpsData.length; i++) {
            const fill = qualityCheck(fpsData[i]).fill;
            const value = (100 - fpsData[i]).toFixed();
            pixels.push(<rect key={i} x={i} y={value} width="1" height="1" fill={fill} />);
        }

        return (
            <g key={i} id="fps">
                {pixels}
            </g>
        );
    }

    return (
        <>
            <svg className={styles.fps_metric_svg} x="0px" y="0px" viewBox={`0 0 ${maxFpsData} 100`}>
                {returnGroup()}
            </svg>
        </>
    );
};

export default FPSMetric;
